import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notes"
export default class extends Controller {
  connect() {
    var self = this;
    this.iframe = document.querySelector('iframe');
    this.player = new Vimeo.Player(this.iframe);

    this.player.getCurrentTime().then((currentTime) => {
      document.getElementById('note_video_time').value = currentTime;
    });
  }
}
